import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course01 from "../../../course/course-01/course";
import lesson0102 from "../../course-01/lesson-02/lesson";
import lesson0104 from "../../course-01/lesson-04/lesson";
import lesson0122 from "../../course-01/lesson-22/lesson";
import lesson0125 from "../../course-01/lesson-25/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "624c4c0f-579b-4b34-b6f8-b645d5fe389d",
    course: {
      id: course01.id,
      slug: course01.slug as string,
      name: course01.name,
      publicId: course01.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course01, lesson0102),
    lesson: lesson0102,
  },
  {
    id: "0e12e56c-e2ad-452f-924f-f780bd5521c3",
    course: {
      id: course01.id,
      slug: course01.slug as string,
      name: course01.name,
      publicId: course01.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course01, lesson0104),
    lesson: lesson0104,
  },
  {
    id: "0789ec21-f65c-446a-8db8-bb52597309e4",
    course: {
      id: course01.id,
      slug: course01.slug as string,
      name: course01.name,
      publicId: course01.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course01, lesson0122),
    lesson: lesson0122,
  },
  {
    id: "f905e3d5-87e7-4b78-97dd-db63e8e6d88c",
    course: {
      id: course01.id,
      slug: course01.slug as string,
      name: course01.name,
      publicId: course01.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course01, lesson0125),
    lesson: lesson0125,
  },
];

export default lessonLinks;
